"use client";

import { createContext, type PropsWithChildren, use, useState } from "react";
import { type StoreApi, useStore } from "zustand";
import {
	type IMicroCartState,
	type MicroCart,
	microcartFactory,
} from "~/lib/stateManagement/sessionState/sessionSlices/microCart";

const MicroCartContext = createContext<StoreApi<IMicroCartState>>(null!);

export const MicroCartProvider = ({ children }: PropsWithChildren) => {
	const [store] = useState(() =>
		microcartFactory({
			carts: new Map<string, MicroCart>(),
			isReset: false,
		}),
	);

	return <MicroCartContext.Provider value={store}>{children}</MicroCartContext.Provider>;
};

export const useMicrocartStore = <T,>(selector: (store: IMicroCartState) => T): T => {
	const microcartStore = use(MicroCartContext);
	if (!microcartStore) {
		throw new Error("useMicrocartStore must be used within a MicroCartProvider");
	}

	return useStore(microcartStore, selector);
};

export const selectors = {
	totalPrice: (state: IMicroCartState) => {
		const values = [...state.carts.values()];
		return values.reduce((acc, cart) => {
			return acc + cart.totalPrice;
		}, 0);
	},
	cartsArray: (state: IMicroCartState): MicroCart[] => {
		return [...state.carts.values()];
	},
};

export const MicroCarts = {
	Needles: "Strikkepinner",
	Recipe: "Oppskrift",
	Yarn: "Garn",
} as const;
export type MicroCarts = (typeof MicroCarts)[keyof typeof MicroCarts];
